<template>
  <div class="section header contact">
    <b-container fluid>
      <b-row align-v="end" class="vcenter">
        <b-col cols="12" class="zi-1" data-aos="zoom-out-up">
          <b-container>
            <h1 class="font-weight-bold mb-5">
              Contact Us
            </h1>
            <dl class="row">
              <dt class="col-6 text-right">Email us</dt>
              <dd class="col-6 text-left">
                hello@orbit.ph
              </dd>
              <!-- <dt class="col-6 text-right">Phone Number</dt>
              <dd class="col-6 text-left">
                +632 6836200
              </dd> -->
              <!-- <dt class="col-6 text-right">Address</dt>
              <dd class="col-6 text-left">
                4/F Unit 4 C&D, Commerce and Industry Plaza Building, Mckinley
                Town Center, Manila, Park Avenue, Taguig, Metro Manila
              </dd> -->
            </dl>
          </b-container>

          <!-- <b-container>
            <b-row class="items">
              <b-col cols="6" md="3">
                <img class="img-fluid" src="@/assets/partner-logo-1.png" />
              </b-col>
              <b-col cols="6" md="3">
                <img class="img-fluid" src="@/assets/partner-logo-2.png" />
              </b-col>
              <b-col cols="6" md="3">
                <img class="img-fluid" src="@/assets/partner-logo-3.png" />
              </b-col>
              <b-col cols="6" md="3">
                <img class="img-fluid" src="@/assets/partner-logo-4.png" />
              </b-col>
            </b-row>
          </b-container> -->
        </b-col>

        <b-col
          cols="12"
          class="zi-1 footer"
          data-aos="zoom-out-up"
          data-aos-delay="500"
        >
          <div class="container">
            <h3 class="font-weight-light mb-4">
              Subscribe to our mailing list
            </h3>
            <b-row class="justify-content-md-center">
              <b-col cols="12" md="6">
                <form @submit.prevent="submit()" validate>
                  <b-input-group>
                    <b-form-input
                      type="email"
                      placeholder="Your email address"
                      size="lg"
                      v-model="item.email"
                      :disabled="loading"
                      required
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button
                        type="submit"
                        size="lg"
                        variant="outline-success"
                        :disabled="loading"
                        >Join</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </form>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import HttpService from '@/services/HttpService'
import NProgress from 'nprogress'
import VueNotifications from 'vue-notifications'

export default {
  data() {
    return {
      item: {},
      loading: false
    }
  },
  methods: {
    submit() {
      this.loading = true
      NProgress.start()
      HttpService.post(this.item)
        .then(response => {
          this.loading = false
          NProgress.done()
          this.showSuccessMsg({
            title: 'Success!',
            message: 'Thank you for subscribing.'
          })
          console.log(response)
        })
        .catch(error => {
          this.loading = false
          NProgress.done()
          this.showWarnMsg({
            title: 'Oops!',
            message: 'Your email address might already subscribed'
          })
          console.log(error)
        })
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: "That's the success!"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: "That's the error"
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  .vcenter {
    padding-bottom: 0;
  }
  .footer {
    background-color: #f2f2f2;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .items {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}
</style>
